  $( document ).ready(function() {

$(window).scroll(function(){
  var sticky = $('sticky-header'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('custom-sticky');
  else sticky.removeClass('custom-sticky');
});
    
    // $('#home-banner-section').slick({
    //   dots: true,
    //   infinite: true,
    //   slidesToShow: 1,
    //   adaptiveHeight: true
    // });
    
     $('#testimonials-inner').slick({
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      adaptiveHeight: true,
       responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });

    $('.services-testimonial-slider').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });
    
    $(".header-bottom__icon svg").click(function() {
      $('html, body').animate({
          scrollTop: $("#questions-section").offset().top
      }, 2000);
    });
    
    $("ul.list-menu.list-menu--inline li:nth-child(3) a.list-menu__item").click(function() {
      $('html, body').animate({
          scrollTop: $("#contact").offset().top
      }, 2000);
    });

});
setTimeout(function() { 
$('.service-page-banner-section').on('init', function(event, slick){
        var dots = $( '.slick-dots li' );
       console.log(dots);
        dots.each( function( k, v){
          $(this).find( 'button' ).addClass( 'heading'+ k );
        });
        var items = slick.$slides;
        items.each( function( k, v){
            var text = $(this).find( 'h3.services-header__caption' ).text();
            $( '.heading' + k ).text(text);
        });
      });
          
     $('.service-page-banner-section').slick({
      dots: true, 
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: true
    });
 }, 2000);